import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";

const IconLightning = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      d="M9.66667 7.89159V9.16659H12.8L11.3333 12.1083V10.8333H8.2L9.66667 7.89159ZM11.3333 0.833252L5.5 12.4999H9.66667V19.1666L15.5 7.49992H11.3333V0.833252Z"
      fill={props.color || "white"}
    />
  </svg>
);

export default IconLightning;